module.exports = __webpack_public_path__ + "static/media/theme-corporate-small.af653f0d.png";